export default "__VITE_ASSET__CdpYtFpd__"